export default __webpack_public_path__ + "static/media/me.f86eca67.jpg";